// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.kb-table {
  border: 1px solid #e4e7ec;
  border-radius: 8px;
  padding-right: 16px;
  padding-left: 16px;
  padding-bottom: 16px;
}
.chatbot-logo {
  text-align: center;
  padding: 12px;
  height: 40px !important;
  width: 40px !important;
  border-radius: 46px;
  text-transform: capitalize;
  margin-right: 20px;
  display: "flex";
  align-items: "center";
  justify-content: "center";
}
.kb-table .MuiDataGrid-columnHeaders {
  font-size: 13px;
  border-bottom: 1px solid #e4e7ec;
  color: #1d1e22;
  text-align: center;
}
.kb-table .MuiDataGrid-columnHeaderTitle {
  font-weight: 600 !important;

}
.kb-table .MuiDataGrid-row:hover {
  cursor: pointer;
  background-color: #eaf3f9 !important;
}

.kb-table .MuiDataGrid-row {
  padding: 0px 15px;
  max-height: 82px !important;
  min-height: 82px !important;
  align-items: center;
  background-color: #ffffff  !important;
}





.agent-pill {
  background-color: #1d1c20;
  border-radius: 31px;
  padding: 4px 12px;
  font-size: 12px;
  font-weight: 400;
  color: #ebe7f7;
}
.kb-table .MuiDataGrid-cell {
  padding: 0px;
  border-bottom: none;
}

.kb-table .MuiDataGrid-cell:focus-within {
  outline: transparent !important;
  outline-width: 0 !important;
  outline-offset: 0 !important;
}

.table-container .MuiDataGrid-columnHeaders {
  border-bottom: 1px solid #e4e7ec;
  color: #667085;
}
.table-container .MuiDataGrid-columnHeaderTitle {
  font-weight: 400 !important;
  font-family: "Inter var";
}
.table-container .MuiDataGrid-row:hover {
  cursor: pointer;
}
.table-container .MuiDataGrid-row {
  padding: 0px 15px;
  max-height: 82px !important;
  min-height: 82px !important;
  align-items: center;
}
.table-container .MuiDataGrid-row:nth-child(odd) {
  background-color: #f9fafb !important;
}

.table-container .MuiDataGrid-cell {
  padding: 0px;
  border-bottom: none;
}

.table-container .MuiDataGrid-cell:focus-within {
  outline: transparent !important;
  outline-width: 0 !important;
  outline-offset: 0 !important;
}

.playground-container {
  background-color: white;
}

.MuiDataGrid-root .MuiDataGrid-row:nth-child(odd) {
  background-color: #f9fafc;
}

.MuiDataGrid-root .MuiDataGrid-row:hover {
  background-color: #e0e8f8;
}

.create-chat-icon {
  color: #7666ce;
}

.MuiDataGrid-root .MuiDataGrid-row:hover > .create-chat-icon {
  color: white !important;
}

.item-heading {
  justify-content: space-between;
  align-items: center;

}

.completed .MuiDataGrid-cellContent {
  background-color: rgba(32, 229, 0, 0.12);
  color: #2eab33;
  border-radius: 30px;
  padding: 5px 15px;
  min-width: 80px;
  text-align: center;
  font-size: 12px;
}

.pending .MuiDataGrid-cellContent {
  background-color: #ffc1074d;
  color: #bb9215;
  border-radius: 30px;
  padding: 5px 15px;
  min-width: 80px;
  text-align: center;
  font-size: 12px;
}

.processing .MuiDataGrid-cellContent {
  background-color: rgba(227, 190, 0, 0.12);
  color: #d9b600;
  border-radius: 30px;
  padding: 5px 15px;
  min-width: 80px;
  text-align: center;
  font-size: 12px;
}

.failed .MuiDataGrid-cellContent {
  background-color: rgba(255, 0, 0, 0.12);
  color: #ec1f1f;
  border-radius: 30px;
  padding: 5px 15px;
  min-width: 80px;
  text-align: center;
  font-size: 12px;
}

.purple-styled-button {
  color: white;
  background-color: #7f56d9;
  border-radius: 8px;
  margin-bottom: 10px;
}

.purple-styled-button:hover {
  border-color: black;
  background-color: #7d4ee3;
  color: white;
}
.purple-outlined-button {
  border: 1px solod rgba(127, 86, 217, 1);
  color: rgba(127, 86, 217, 1);
  border-radius: 8px;
}

.styled-button {
  color: white;
  background-color: #7C53FE;
  border-radius: 8px;
  max-width: fit-content;
  padding: 22px 12px;
  place-content: flex-center;
  font-weight: 400;
}

.styled-button:hover {
  color: white;
  background-color: #101828;
  border-radius: 8px;
  border-color: #8974BACC;
}

@media (max-width: 912px) {
  .item-heading {
    flex-direction: column;
    padding: 0;
  }

  .item-heading span {
    font-size: 12px;
  }
}

.element {
  display: flex;
  flex-direction: row;
  align-items: stretch;
  justify-content: flex-start;
  flex-wrap: wrap;
}

.left-side {
  display: flex;
  flex-direction: column;
  align-items: left;
  text-align: left;
  width: 90%;
}

.right-side {
  display: flex;
  flex-direction: column;
  align-items: start;
  vertical-align: center;
  text-align: left;
  width: 100%;
}

.title {
  font-weight: bold;
  margin-top: 30px;
}

.description {
  margin-top: 5px;
}

.text-field {
  margin-left: 10px; /* Adjust the margin as needed */
}

.options-card {
  border: 1px solid #e6e6e6;
  background-color: #f9f9f9;
  border-radius: 4px;
}

.options-card-title {
  font-size: 14px;
  font-weight: 400;
  color: #101828;
}

.options-card-body {
  font-size: 13px;
  font-weight: "regular";
  color: #667085;
  text-align: left;
}
`, "",{"version":3,"sources":["webpack://./src/app/main/dashboards/knowledge_base/kb.css"],"names":[],"mappings":"AAAA;EACE,yBAAyB;EACzB,kBAAkB;EAClB,mBAAmB;EACnB,kBAAkB;EAClB,oBAAoB;AACtB;AACA;EACE,kBAAkB;EAClB,aAAa;EACb,uBAAuB;EACvB,sBAAsB;EACtB,mBAAmB;EACnB,0BAA0B;EAC1B,kBAAkB;EAClB,eAAe;EACf,qBAAqB;EACrB,yBAAyB;AAC3B;AACA;EACE,eAAe;EACf,gCAAgC;EAChC,cAAc;EACd,kBAAkB;AACpB;AACA;EACE,2BAA2B;;AAE7B;AACA;EACE,eAAe;EACf,oCAAoC;AACtC;;AAEA;EACE,iBAAiB;EACjB,2BAA2B;EAC3B,2BAA2B;EAC3B,mBAAmB;EACnB,qCAAqC;AACvC;;;;;;AAMA;EACE,yBAAyB;EACzB,mBAAmB;EACnB,iBAAiB;EACjB,eAAe;EACf,gBAAgB;EAChB,cAAc;AAChB;AACA;EACE,YAAY;EACZ,mBAAmB;AACrB;;AAEA;EACE,+BAA+B;EAC/B,2BAA2B;EAC3B,4BAA4B;AAC9B;;AAEA;EACE,gCAAgC;EAChC,cAAc;AAChB;AACA;EACE,2BAA2B;EAC3B,wBAAwB;AAC1B;AACA;EACE,eAAe;AACjB;AACA;EACE,iBAAiB;EACjB,2BAA2B;EAC3B,2BAA2B;EAC3B,mBAAmB;AACrB;AACA;EACE,oCAAoC;AACtC;;AAEA;EACE,YAAY;EACZ,mBAAmB;AACrB;;AAEA;EACE,+BAA+B;EAC/B,2BAA2B;EAC3B,4BAA4B;AAC9B;;AAEA;EACE,uBAAuB;AACzB;;AAEA;EACE,yBAAyB;AAC3B;;AAEA;EACE,yBAAyB;AAC3B;;AAEA;EACE,cAAc;AAChB;;AAEA;EACE,uBAAuB;AACzB;;AAEA;EACE,8BAA8B;EAC9B,mBAAmB;;AAErB;;AAEA;EACE,wCAAwC;EACxC,cAAc;EACd,mBAAmB;EACnB,iBAAiB;EACjB,eAAe;EACf,kBAAkB;EAClB,eAAe;AACjB;;AAEA;EACE,2BAA2B;EAC3B,cAAc;EACd,mBAAmB;EACnB,iBAAiB;EACjB,eAAe;EACf,kBAAkB;EAClB,eAAe;AACjB;;AAEA;EACE,yCAAyC;EACzC,cAAc;EACd,mBAAmB;EACnB,iBAAiB;EACjB,eAAe;EACf,kBAAkB;EAClB,eAAe;AACjB;;AAEA;EACE,uCAAuC;EACvC,cAAc;EACd,mBAAmB;EACnB,iBAAiB;EACjB,eAAe;EACf,kBAAkB;EAClB,eAAe;AACjB;;AAEA;EACE,YAAY;EACZ,yBAAyB;EACzB,kBAAkB;EAClB,mBAAmB;AACrB;;AAEA;EACE,mBAAmB;EACnB,yBAAyB;EACzB,YAAY;AACd;AACA;EACE,uCAAuC;EACvC,4BAA4B;EAC5B,kBAAkB;AACpB;;AAEA;EACE,YAAY;EACZ,yBAAyB;EACzB,kBAAkB;EAClB,sBAAsB;EACtB,kBAAkB;EAClB,0BAA0B;EAC1B,gBAAgB;AAClB;;AAEA;EACE,YAAY;EACZ,yBAAyB;EACzB,kBAAkB;EAClB,uBAAuB;AACzB;;AAEA;EACE;IACE,sBAAsB;IACtB,UAAU;EACZ;;EAEA;IACE,eAAe;EACjB;AACF;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,oBAAoB;EACpB,2BAA2B;EAC3B,eAAe;AACjB;;AAEA;EACE,aAAa;EACb,sBAAsB;EACtB,iBAAiB;EACjB,gBAAgB;EAChB,UAAU;AACZ;;AAEA;EACE,aAAa;EACb,sBAAsB;EACtB,kBAAkB;EAClB,sBAAsB;EACtB,gBAAgB;EAChB,WAAW;AACb;;AAEA;EACE,iBAAiB;EACjB,gBAAgB;AAClB;;AAEA;EACE,eAAe;AACjB;;AAEA;EACE,iBAAiB,EAAE,gCAAgC;AACrD;;AAEA;EACE,yBAAyB;EACzB,yBAAyB;EACzB,kBAAkB;AACpB;;AAEA;EACE,eAAe;EACf,gBAAgB;EAChB,cAAc;AAChB;;AAEA;EACE,eAAe;EACf,sBAAsB;EACtB,cAAc;EACd,gBAAgB;AAClB","sourcesContent":[".kb-table {\n  border: 1px solid #e4e7ec;\n  border-radius: 8px;\n  padding-right: 16px;\n  padding-left: 16px;\n  padding-bottom: 16px;\n}\n.chatbot-logo {\n  text-align: center;\n  padding: 12px;\n  height: 40px !important;\n  width: 40px !important;\n  border-radius: 46px;\n  text-transform: capitalize;\n  margin-right: 20px;\n  display: \"flex\";\n  align-items: \"center\";\n  justify-content: \"center\";\n}\n.kb-table .MuiDataGrid-columnHeaders {\n  font-size: 13px;\n  border-bottom: 1px solid #e4e7ec;\n  color: #1d1e22;\n  text-align: center;\n}\n.kb-table .MuiDataGrid-columnHeaderTitle {\n  font-weight: 600 !important;\n\n}\n.kb-table .MuiDataGrid-row:hover {\n  cursor: pointer;\n  background-color: #eaf3f9 !important;\n}\n\n.kb-table .MuiDataGrid-row {\n  padding: 0px 15px;\n  max-height: 82px !important;\n  min-height: 82px !important;\n  align-items: center;\n  background-color: #ffffff  !important;\n}\n\n\n\n\n\n.agent-pill {\n  background-color: #1d1c20;\n  border-radius: 31px;\n  padding: 4px 12px;\n  font-size: 12px;\n  font-weight: 400;\n  color: #ebe7f7;\n}\n.kb-table .MuiDataGrid-cell {\n  padding: 0px;\n  border-bottom: none;\n}\n\n.kb-table .MuiDataGrid-cell:focus-within {\n  outline: transparent !important;\n  outline-width: 0 !important;\n  outline-offset: 0 !important;\n}\n\n.table-container .MuiDataGrid-columnHeaders {\n  border-bottom: 1px solid #e4e7ec;\n  color: #667085;\n}\n.table-container .MuiDataGrid-columnHeaderTitle {\n  font-weight: 400 !important;\n  font-family: \"Inter var\";\n}\n.table-container .MuiDataGrid-row:hover {\n  cursor: pointer;\n}\n.table-container .MuiDataGrid-row {\n  padding: 0px 15px;\n  max-height: 82px !important;\n  min-height: 82px !important;\n  align-items: center;\n}\n.table-container .MuiDataGrid-row:nth-child(odd) {\n  background-color: #f9fafb !important;\n}\n\n.table-container .MuiDataGrid-cell {\n  padding: 0px;\n  border-bottom: none;\n}\n\n.table-container .MuiDataGrid-cell:focus-within {\n  outline: transparent !important;\n  outline-width: 0 !important;\n  outline-offset: 0 !important;\n}\n\n.playground-container {\n  background-color: white;\n}\n\n.MuiDataGrid-root .MuiDataGrid-row:nth-child(odd) {\n  background-color: #f9fafc;\n}\n\n.MuiDataGrid-root .MuiDataGrid-row:hover {\n  background-color: #e0e8f8;\n}\n\n.create-chat-icon {\n  color: #7666ce;\n}\n\n.MuiDataGrid-root .MuiDataGrid-row:hover > .create-chat-icon {\n  color: white !important;\n}\n\n.item-heading {\n  justify-content: space-between;\n  align-items: center;\n\n}\n\n.completed .MuiDataGrid-cellContent {\n  background-color: rgba(32, 229, 0, 0.12);\n  color: #2eab33;\n  border-radius: 30px;\n  padding: 5px 15px;\n  min-width: 80px;\n  text-align: center;\n  font-size: 12px;\n}\n\n.pending .MuiDataGrid-cellContent {\n  background-color: #ffc1074d;\n  color: #bb9215;\n  border-radius: 30px;\n  padding: 5px 15px;\n  min-width: 80px;\n  text-align: center;\n  font-size: 12px;\n}\n\n.processing .MuiDataGrid-cellContent {\n  background-color: rgba(227, 190, 0, 0.12);\n  color: #d9b600;\n  border-radius: 30px;\n  padding: 5px 15px;\n  min-width: 80px;\n  text-align: center;\n  font-size: 12px;\n}\n\n.failed .MuiDataGrid-cellContent {\n  background-color: rgba(255, 0, 0, 0.12);\n  color: #ec1f1f;\n  border-radius: 30px;\n  padding: 5px 15px;\n  min-width: 80px;\n  text-align: center;\n  font-size: 12px;\n}\n\n.purple-styled-button {\n  color: white;\n  background-color: #7f56d9;\n  border-radius: 8px;\n  margin-bottom: 10px;\n}\n\n.purple-styled-button:hover {\n  border-color: black;\n  background-color: #7d4ee3;\n  color: white;\n}\n.purple-outlined-button {\n  border: 1px solod rgba(127, 86, 217, 1);\n  color: rgba(127, 86, 217, 1);\n  border-radius: 8px;\n}\n\n.styled-button {\n  color: white;\n  background-color: #7C53FE;\n  border-radius: 8px;\n  max-width: fit-content;\n  padding: 22px 12px;\n  place-content: flex-center;\n  font-weight: 400;\n}\n\n.styled-button:hover {\n  color: white;\n  background-color: #101828;\n  border-radius: 8px;\n  border-color: #8974BACC;\n}\n\n@media (max-width: 912px) {\n  .item-heading {\n    flex-direction: column;\n    padding: 0;\n  }\n\n  .item-heading span {\n    font-size: 12px;\n  }\n}\n\n.element {\n  display: flex;\n  flex-direction: row;\n  align-items: stretch;\n  justify-content: flex-start;\n  flex-wrap: wrap;\n}\n\n.left-side {\n  display: flex;\n  flex-direction: column;\n  align-items: left;\n  text-align: left;\n  width: 90%;\n}\n\n.right-side {\n  display: flex;\n  flex-direction: column;\n  align-items: start;\n  vertical-align: center;\n  text-align: left;\n  width: 100%;\n}\n\n.title {\n  font-weight: bold;\n  margin-top: 30px;\n}\n\n.description {\n  margin-top: 5px;\n}\n\n.text-field {\n  margin-left: 10px; /* Adjust the margin as needed */\n}\n\n.options-card {\n  border: 1px solid #e6e6e6;\n  background-color: #f9f9f9;\n  border-radius: 4px;\n}\n\n.options-card-title {\n  font-size: 14px;\n  font-weight: 400;\n  color: #101828;\n}\n\n.options-card-body {\n  font-size: 13px;\n  font-weight: \"regular\";\n  color: #667085;\n  text-align: left;\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
